export { default as DirectorDeals, getServerSideProps} from './DirectorDeals';